// extracted by mini-css-extract-plugin
export default {"mdc-typography-font-family":"Montserrat, sans-serif","red":"#bb2353","green":"#33b53e","gray":"#666d70","pie-chart__container":"PieChart_pie-chart__container__L4xte"};